import React, { useEffect } from 'react';
import FormSelect from '@app/component/form/input/select/FormSelect';
import { AlertRecipientsType } from '@app/model/alert/AlertRecipientsType';
import FormMultiSelect from '@app/component/form/input/select/FormMultiSelect';
import { useQuery } from '@tanstack/react-query';
import { CompanyProfileService } from '@app/model/company_profile/service/CompanyProfileService';
import { useSelectedCompanyHotel } from '@app/site/secured/rateshopper/rates/provider/useSelectedCompanyHotel';


export const AlertRecipientsFragment: React.FunctionComponent<{ form: any }> = ({ form }) => {

	const recipientsType = form.watch('recipientsType');

	const { companyHotel } = useSelectedCompanyHotel()!;

	const { data: outputs, isSuccess } = useQuery({
		queryFn: () => CompanyProfileService.findCompanyProfilesWithAccessToCompanyHotel(companyHotel.id),
		queryKey: [],
	});

	const typeWatch = form.watch('recipientsType');

	useEffect(() => {
		if (typeWatch === AlertRecipientsType.NONE || typeWatch === AlertRecipientsType.ALL) {
			form.setValue('recipientProfileIds', []);
		}
	}, [typeWatch]);

	return <div className="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-gray-900/10 pb-12 md:grid-cols-3">
		<div>
			<h2 className="text-base font-semibold leading-7 text-gray-900">Email Recipients</h2>
			<p className="mt-1 text-sm leading-6 text-gray-600">
				Select who will get the email alert
			</p>
		</div>
		<div className="grid grid-cols-2 gap-x-6 gap-y-8 sm:grid-cols-2 md:col-span-2">
			<div className="col-span-1">
				<FormSelect form={form} name="recipientsType" size="w-full" optionsSize="large" options={[
					{ id: 'NONE', label: 'None', value: AlertRecipientsType.NONE },
					{ id: 'ALL', label: 'All Users', value: AlertRecipientsType.ALL },
					{ id: 'SELECTED', label: 'Selected Recipients', value: AlertRecipientsType.SELECTED },
				]} />
			</div>
			<div className="col-span-1">
				{isSuccess &&
					<FormMultiSelect name="recipientProfileIds" form={form} placeholder="Select Recipients" hideAllSelection
													 disabled={typeWatch === AlertRecipientsType.ALL || typeWatch === AlertRecipientsType.NONE}
													 isRequired={recipientsType === AlertRecipientsType.SELECTED}
													 options={outputs.map(({ profile }) => {
														 return { id: '' + profile.id, label: profile.name, value: profile.id };
													 })} />}
			</div>
		</div>
	</div>;

};